import { useMutation } from "@tanstack/react-query";
import { updateUserInfo } from "../../../api/requests/updateUserInfo";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useUpdateUser = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: updateUserInfo,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
